"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APOS_STANDARD_PURPOSE_TAGS = exports.APosPurposeTagSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
/**
 * Module 29 — Oil Blending (Phase 2)
 *
 * PurposeTag — seed lookup of mood / purpose tags used by the suggestion
 * engine and customer-facing browse UI (storefront-app `MoodBrowsePage`).
 *
 * Table layout:
 *   PK = tenantId   (or `_global` for shared seed)
 *   SK = tag        (kebab-case slug, e.g. `stress-relief`, `sleep`)
 */
exports.APosPurposeTagSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    tag: zod_1.z
        .string()
        .min(1)
        .max(60)
        .regex(/^[a-z][a-z0-9_-]*$/, 'must be lowercase kebab- or snake-case slug'),
    display_name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().max(500).optional(),
    emoji: zod_1.z.string().max(8).optional(),
    // Categories help group tags in the UI ("moods", "occasions", "wellness").
    category: zod_1.z.enum(['mood', 'occasion', 'wellness', 'other']).default('mood'),
    is_active: zod_1.z.boolean().default(true),
    sort_order: zod_1.z.number().int().nonnegative().default(0),
    createdAt: zod_1.z.number().describe('Unix ms'),
    updatedAt: zod_1.z.number().describe('Unix ms'),
});
/**
 * The 14 standard seeded tags (per data-model.md). Used by
 * `seedPurposeTags` migration.
 */
exports.APOS_STANDARD_PURPOSE_TAGS = [
    { tag: 'sleep', display_name: 'Sleep', category: 'wellness', emoji: '🌙' },
    { tag: 'relaxation', display_name: 'Relaxation', category: 'mood', emoji: '🛀' },
    { tag: 'stress_relief', display_name: 'Stress Relief', category: 'wellness', emoji: '🧘' },
    { tag: 'focus', display_name: 'Focus', category: 'wellness', emoji: '🎯' },
    { tag: 'energy', display_name: 'Energy', category: 'mood', emoji: '⚡' },
    { tag: 'mood_boost', display_name: 'Mood Boost', category: 'mood', emoji: '✨' },
    { tag: 'meditation', display_name: 'Meditation', category: 'wellness', emoji: '🕉️' },
    { tag: 'romance', display_name: 'Romance', category: 'occasion', emoji: '💕' },
    { tag: 'cold_flu', display_name: 'Cold & Flu', category: 'wellness', emoji: '🤒' },
    { tag: 'headache', display_name: 'Headache Relief', category: 'wellness', emoji: '💆' },
    { tag: 'confidence', display_name: 'Confidence', category: 'mood', emoji: '💪' },
    { tag: 'grounding', display_name: 'Grounding', category: 'wellness', emoji: '🌳' },
    { tag: 'spiritual', display_name: 'Spiritual', category: 'wellness', emoji: '🙏' },
    { tag: 'cleansing', display_name: 'Cleansing', category: 'wellness', emoji: '🌿' },
];
//# sourceMappingURL=purpose-tag.schema.js.map